<div id="content" *ngIf="appTheme =='sytnerTheme'" #content class="invoice">
    <div class="invoice-header flmid space-between">
        <div class="left">
            <h1 translate>lblInvoice</h1>
        </div>
        <div class="right txtright">
            <img [src]="themeLogo" class="dealer-logo-header" alt="" />
            <h3>{{ customerDealerDetails.DealerName }}</h3>
            <address>
        <p>{{customerDealerDetails.DealerAddress1}}{{ customerDealerDetails.DealerAddress2 ? ', ' + customerDealerDetails.DealerAddress2 : '' }}</p>
        <p>
          {{ customerDealerDetails.DealerCity }} |
          {{ customerDealerDetails.Country }} | {{ customerDealerDetails.DealerPinCode }}
        </p>
       <span translate>lblTel</span>: {{ customerDealerDetails.LandlineNo }}
      </address>
            <h4>
                <p><span translate>lblOpeningHours</span>: {{ customerDealerDetails.OpeningHours }}</p>
            </h4>
        </div>
    </div>
    <div class="invoice-body">
        <div class="">

            <h5 style="width: 800px;"><span translate>lblInvoiceTo</span>:</h5>

            <h4><strong>{{ customerDealerDetails.CustomerName }}</strong></h4>
            <div class="flmid brand-details mb10">
                <img *ngIf="imageSrc" [src]="imageSrc" alt="" />
                <p>
                    <strong>{{ customerDealerDetails.CompanyModel }}</strong>
                </p>
            </div>
            <h6>
                <span translate>lblLPNumber</span><strong>: {{ customerDealerDetails.LicensePlateNo }}</strong>
            </h6>
            <h6>
                <span translate>lblOrderNumber</span><strong>: {{ customerDealerDetails.OrderNumber }}</strong>
            </h6>
        </div>
    </div>
    <div class="invoice-table">
        <table border="0" aria-describedby="">
            <thead>
                <tr>
                    <th id="" translate>lblJob</th>
                    <th id="" style="text-align: right;" class="txtright" translate><span translate>lblPrice</span>(Inc.VAT)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let service of servicesDetails">
                    <td>{{ service.ServiceName }}</td>
                    <td style="text-align: right;">{{ service.Price | currencySymbolSpace: currencyType }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="grand-total">
        <span translate>lblGrandTotal</span>:
        <span style="margin: 0; text-transform: lowercase;">
      {{ grandTotal| currencySymbolSpace: currencyType}}
    </span>
    </div>
    <div class="clearfix"></div>
</div>


<div id="content" #content *ngIf="appTheme !='sytnerTheme'" class="invoice newpdf">
    <div class="logobigi">
        <img [src]="themeLogo" class="dealer-logo-header" alt="" />
    </div>
    <div class="invoice-header flmid space-between">
        <div class="left">
            <h1 translate>lblInvoice</h1>
        </div>
        <div class="right txtright">
            <h3>{{ customerDealerDetails.DealerName }}</h3>
            <address>
        <p>{{ customerDealerDetails.DealerAddress1 }}</p>
        <p>
          {{ customerDealerDetails.DealerAddress2 }} |
          {{ customerDealerDetails.Country }}
        </p>
        <p translate>lblTel</p>: {{ customerDealerDetails.LandlineNo }}
      </address>
            <h4 translate>
                <p><span translate>lblOpeningHours</span>:</p>
                <span translate>lblMondayToSaturday </span>: {{ customerDealerDetails.OPENINGHRS }}
            </h4>
        </div>
    </div>
    <div class="invoice-body right txtright">
        <div class="">
            <h5 style="width: 800px;" translate>lblInvoiceTo:</h5>
            <h4><strong>{{ customerDealerDetails.CustomerName }}</strong></h4>
            <div class="flmid brand-details mb10">
                <img *ngIf="imageSrc" [src]="imageSrc" alt="" />
                <p>
                    <strong>{{ customerDealerDetails.CompanyModel }}</strong>
                </p>
            </div>
            <h6 translate>
                <span translate>lblLPNumber:</span><strong> {{ customerDealerDetails.LicensePlateNo }}</strong>
            </h6>
            <h6>
                <span translate>lblOrderNumber:</span><strong> {{ customerDealerDetails.OrderNumber }}</strong>
            </h6>
        </div>
    </div>
    <div class="invoice-table">
        <table border="0" aria-describedby="">
            <thead>
                <tr>
                    <th id="" translate>lblJob</th>
                    <th id="" style="text-align: right;" class="txtright" translate>lblPrice(Inc.VAT)</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let service of servicesDetails">
                    <td>{{ service.ServiceName }}</td>
                    <td style="text-align: right;">{{ service.Price | currencySymbolSpace: currencyType }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="grand-total">
        <span translate>lblGrandTotal:</span> <span style="margin: 0; text-transform: lowercase;">
      {{ grandTotal| currencySymbolSpace: currencyType}}
    </span>
    </div>
    <div class="clearfix"></div>
</div>